<template>
  <main class="page-operative page-operative-project page-operative-project-library-expense page-operative-project-library-expense-edit">
    <div class="container">
      <PageTitle>Modifica costo figurato (libreria)</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Costo figurato (libreria) da modificare non trovato</div>
      <FormImputedCost v-else-if="company && userCanEdit" :costo.sync="cost" edit @saved="saveCost" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '@/mixins/operativePage';

export default {
  name: 'page-operative-company-project-library-expense-edit',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('@/views/components/Layout/LayoutOperative/PageTitle'),
    FormImputedCost: () => import('@/views/components/Operative/Form/FormImputedCost'),
  },
  data () {
    return {
      cost: null,
      loading: true,
      errorLoadingData: false,
    };
  },
  methods: {
    saveCost (costo) {
      this.$api.updateImputedCost(this.company.id, costo.id, costo)
        .then(() => {
          this.$router.push({
            name: 'operative-company.projects.library.imputedCosts.list',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getImputedCost(this.company.id, this.$route.params.imputedCostId)
          .then(res => {
            this.cost = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
